export type BuildBrand = 'presentear' | 'chadebb' | 'chadebebe' | 'listacasamento';

export type BrandHomeCopy = {
  title: string;
  subtitle: string;
  ctaPrimary: string;
  ctaSecondary: string;
  quickBenefits: string[];
};

export type BrandCopyBundle = {
  home: BrandHomeCopy;
};

export type BrandHeadAssets = {
  favicon96: string;
  faviconSvg: string;
  faviconIco: string;
  appleTouchIcon: string;
  appIcon192: string;
  appIcon512: string;
  themeColor: string;
};

export type BrandVisualAssets = {
  homeLogoSrc: string;
  homeLogoAlt: string;
  defaultOgImagePath: string;
  templateIconVideoSrc: {
    casamento: string;
    'cha-de-bebe': string;
    aniversario: string;
    vaquinha: string;
  };
  head: BrandHeadAssets;
};

export type BuildConfig = {
  brand: BuildBrand;
  displayName: string;
  logoShort: string;
  metaPixelId?: string;
  microsoftUetTagId?: string;
  googleTagId?: string;
  googleAdsId?: string;
  googleAdsConversionLabel?: string;
  googleAdsEditListConversionLabel?: string;
  /** Conversão "Ver oferta" na página de Ideias (clique no produto). Vazio = não dispara. */
  googleAdsViewOfferConversionLabel?: string;
  tracking: {
    createListClickEvent: string;
    createListSuccessEvent: string;
  };
  demoListSlug: string;
  forceTemplateSlug?: string;
  hideTemplateSelector: boolean;
  themeKey: BuildBrand;
  copy: BrandCopyBundle;
  badgeColors: {
    bg: string;
    border: string;
    text: string;
  };
  assets: BrandVisualAssets;
};

export const DEFAULT_BUILD_BRAND: BuildBrand = 'presentear';

export const BUILD_CONFIGS: Record<BuildBrand, BuildConfig> = {
  presentear: {
    brand: 'presentear',
    displayName: 'Presentear.Net',
    logoShort: 'Presentear',
    googleTagId: 'G-0WL36W2M28',
    googleAdsId: 'AW-17950436531',
    googleAdsConversionLabel: 'G8a_CLXFn7kcELPZt-9C',
    googleAdsEditListConversionLabel: 'LxQaCJnN9bkcELPZt-9C',
    googleAdsViewOfferConversionLabel: 'LGe6CJjbu8AcELPZt-9C',
    tracking: {
      createListClickEvent: 'create_list_click',
      createListSuccessEvent: 'create_list_success',
    },
    demoListSlug: 'demo',
    hideTemplateSelector: false,
    themeKey: 'presentear',
    copy: {
      home: {
        title: 'Crie sua lista online',
        subtitle: '',
        ctaPrimary: 'Criar lista',
        ctaSecondary: 'Ver um modelo',
        quickBenefits: ['zero taxas', 'Receba via Pix'],
      },
    },
    badgeColors: {
      bg: '#ffffff',
      border: 'rgba(255,255,255,0.75)',
      text: '#355f73',
    },
    assets: {
      homeLogoSrc: '/branding/presentear/logo512.png',
      homeLogoAlt: 'Presentear.Net',
      defaultOgImagePath: '/branding/presentear/logo512.png',
      templateIconVideoSrc: {
        casamento: '/branding/icons/casamento-icon.webm',
        'cha-de-bebe': '/branding/icons/chadebebe-icon.webm',
        aniversario: '/branding/icons/aniversario-icon.webm',
        vaquinha: '/branding/icons/vaquinha-icon.webm',
      },
      head: {
        favicon96: '/branding/presentear/favicon-96x96.png',
        faviconSvg: '/branding/presentear/favicon.svg',
        faviconIco: '/branding/presentear/favicon.ico',
        appleTouchIcon: '/branding/presentear/apple-touch-icon.png',
        appIcon192: '/branding/presentear/logo192.png',
        appIcon512: '/branding/presentear/logo512.png',
        themeColor: '#d4af37',
      },
    },
  },
  chadebb: {
    brand: 'chadebb',
    displayName: 'ChaDebb.com',
    logoShort: 'ChaDebb',
    tracking: {
      createListClickEvent: 'create_list_click',
      createListSuccessEvent: 'create_list_success',
    },
    demoListSlug: 'demo',
    hideTemplateSelector: false,
    themeKey: 'presentear',
    copy: {
      home: {
        title: 'Crie sua lista online',
        subtitle: '0% de taxas • Receba via Pix.',
        ctaPrimary: 'Criar lista',
        ctaSecondary: 'Ver um modelo',
        quickBenefits: ['zero taxas', 'Receba via Pix'],
      },
    },
    badgeColors: {
      bg: '#ffffff',
      border: 'rgba(255,255,255,0.75)',
      text: '#355f73',
    },
    assets: {
      homeLogoSrc: '/branding/presentear/logo512.png',
      homeLogoAlt: 'ChaDebb',
      defaultOgImagePath: '/branding/presentear/logo512.png',
      templateIconVideoSrc: {
        casamento: '/branding/icons/casamento-icon.webm',
        'cha-de-bebe': '/branding/icons/chadebebe-icon.webm',
        aniversario: '/branding/icons/aniversario-icon.webm',
        vaquinha: '/branding/icons/vaquinha-icon.webm',
      },
      head: {
        favicon96: '/branding/presentear/favicon-96x96.png',
        faviconSvg: '/branding/presentear/favicon.svg',
        faviconIco: '/branding/presentear/favicon.ico',
        appleTouchIcon: '/branding/presentear/apple-touch-icon.png',
        appIcon192: '/branding/presentear/logo192.png',
        appIcon512: '/branding/presentear/logo512.png',
        themeColor: '#d4af37',
      },
    },
  },
  chadebebe: {
    brand: 'chadebebe',
    displayName: 'ChaDeBebe.Net',
    logoShort: 'Cha de Bebe',
    metaPixelId: '1714542006392624',
    microsoftUetTagId: '97247542',
    googleTagId: 'G-27WNFFCFWK',
    tracking: {
      createListClickEvent: 'create_list_click',
      createListSuccessEvent: 'create_list_success',
    },
    demoListSlug: 'demo-cha-de-bebe',
    forceTemplateSlug: 'cha-de-bebe',
    hideTemplateSelector: true,
    themeKey: 'chadebebe',
    copy: {
      home: {
        title: 'Seu chá de bebê bonito, rápido e sem taxas',
        subtitle:
          'Crie a lista em 1 clique, compartilhe com a família e receba no Pix com mensagens carinhosas.',
        ctaPrimary: 'Começar meu chá de bebê',
        ctaSecondary: 'Ver uma lista pronta',
        quickBenefits: ['100% grátis'],
      },
    },
    badgeColors: {
      bg: '#f7fbff',
      border: '#d7e6ef',
      text: '#2f5b70',
    },
    assets: {
      homeLogoSrc: '/branding/chadebebe/logo512.png',
      homeLogoAlt: 'ChaDeBebe.Net',
      defaultOgImagePath: '/branding/chadebebe/social-share-512.png',
      templateIconVideoSrc: {
        casamento: '/branding/icons/casamento-icon.webm',
        'cha-de-bebe': '/branding/icons/chadebebe-icon.webm',
        aniversario: '/branding/icons/aniversario-icon.webm',
        vaquinha: '/branding/icons/vaquinha-icon.webm',
      },
      head: {
        favicon96: '/branding/chadebebe/favicon-96x96.png',
        faviconSvg: '/branding/chadebebe/favicon.svg',
        faviconIco: '/branding/chadebebe/favicon.ico',
        appleTouchIcon: '/branding/chadebebe/apple-touch-icon.png',
        appIcon192: '/branding/chadebebe/logo192.png',
        appIcon512: '/branding/chadebebe/logo512.png',
        themeColor: '#f08f7d',
      },
    },
  },
  listacasamento: {
    brand: 'listacasamento',
    displayName: 'ListaCasamento.Net',
    logoShort: 'Lista Casamento',
    forceTemplateSlug: 'casamento',
    tracking: {
      createListClickEvent: 'create_list_click',
      createListSuccessEvent: 'create_list_success',
    },
    demoListSlug: 'demo',
    hideTemplateSelector: true,
    themeKey: 'listacasamento',
    copy: {
      home: {
        title: 'Crie sua lista online',
        subtitle: '0% de taxas • Receba via Pix.',
        ctaPrimary: 'Criar lista',
        ctaSecondary: 'Ver um modelo',
        quickBenefits: ['zero taxas', 'Receba via Pix'],
      },
    },
    badgeColors: {
      bg: '#fffdf7',
      border: '#ece0c5',
      text: '#6d5840',
    },
    assets: {
      homeLogoSrc: '/branding/listacasamento/logo512.png',
      homeLogoAlt: 'ListaCasamento.Net',
      defaultOgImagePath: '/branding/listacasamento/logo512.png',
      templateIconVideoSrc: {
        casamento: '/branding/icons/casamento-icon.webm',
        'cha-de-bebe': '/branding/icons/chadebebe-icon.webm',
        aniversario: '/branding/icons/aniversario-icon.webm',
        vaquinha: '/branding/icons/vaquinha-icon.webm',
      },
      head: {
        favicon96: '/branding/listacasamento/favicon-96x96.png',
        faviconSvg: '/branding/listacasamento/favicon.svg',
        faviconIco: '/branding/listacasamento/favicon.ico',
        appleTouchIcon: '/branding/listacasamento/apple-touch-icon.png',
        appIcon192: '/branding/listacasamento/logo192.png',
        appIcon512: '/branding/listacasamento/logo512.png',
        themeColor: '#d4af37',
      },
    },
  },
};
